import React, {useState} from "react";
import "./Radio.css";
import RiddleCard from "../RiddleCard/RiddleCard";

const Radio = ({currentFreq, currentlyCorrect, overWriteFunction, index}) => {
    const mainDiv = (
        <>
            <h4 className="radio-display">freq: {currentFreq}</h4>
        </>
    );
    return (
        <RiddleCard allSolved={currentlyCorrect} mainInfo={mainDiv} title={"Radio"} connected={currentFreq !== null} overwriteString={overWriteFunction} index={index}></RiddleCard>
    )
}

export default Radio;